import { Record } from 'immutable';
import {
  UPDATE_FILTER,
  CLEAR_SHOPS,
  REQUEST_SHOPS,
  RECEIVE_SHOPS,
  RECEIVE_SHOP,
} from '../constants';
import { transformShopAddress } from '../utils/helpers';


const InitialState = Record({
  items: [],
  city: '',
  searchName: '',
  lat: 0,
  lng: 0,
  isFetching: false,
});

const initialState = new InitialState();

export default function shopsReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_SHOPS:
      return state.set('isFetching', true);
    case CLEAR_SHOPS:
      return state.set('items', []);

    case UPDATE_FILTER: {
      const { lat, lng, searchName, city } = action.payload;

      return state.withMutations((newState) => {
        if (newState.get('lat') !== lat) {
          newState.set('lat', lat);
        }
        if (newState.get('lng') !== lng) {
          newState.set('lng', lng);
        }
        if (newState.get('city') !== city) {
          newState.set('city', city);
        }
        if (newState.get('searchName') !== searchName) {
          newState.set('searchName', searchName);
        }
      });
    }

    case RECEIVE_SHOPS: {
      const shops = action.payload
        .filter(({ id }) => state.get('items').every(item => item.id !== id))
        .map(transformShopAddress);
      return state.withMutations(s => s.set('items', s.get('items').concat(shops)).set('isFetching', false));
    }

    case RECEIVE_SHOP: {
      const item = { ...action.payload };
      let address = '';
      if (item.address) {
        // eslint-disable-next-line no-shadow
        const { street, city, state, zip, country } = item.address;
        item.city = city;
        item.zip = zip;
        item.country = country;
        if (street && city && state) {
          address = `${street}, ${city}, ${state}`;
        }
      }
      item.address = address;
      return state.set('items', state.get('items').concat([item]));
    }


    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/shops/reducer.js